import type { OfflineSyncMetadataRecord } from "../../types/requisition";
import { getOfflineRecord, getSyncMetadataKey, upsertOfflineRecord } from "./schema";

const DEFAULT_METADATA: OfflineSyncMetadataRecord = {
  key: "requisition_sync",
  nextEventSequence: 1,
  lastSyncedAt: null,
  lastReconciliationAt: null,
  lastQueueReplayAt: null,
  lastRequisitionCacheAt: null,
  lastPurchaseOrderCacheAt: null,
  lastVendorCacheAt: null,
  lastCatalogCacheAt: null,
  lastComponentTreeCacheAt: null,
  lastError: null,
};

export async function getSyncMetadata(): Promise<OfflineSyncMetadataRecord> {
  const key = getSyncMetadataKey();
  const metadata = await getOfflineRecord<OfflineSyncMetadataRecord>("syncMetadata", key);
  if (metadata) {
    return metadata;
  }

  await upsertOfflineRecord("syncMetadata", key, DEFAULT_METADATA);
  return DEFAULT_METADATA;
}

export async function allocateNextEventSequence(): Promise<number> {
  const metadata = await getSyncMetadata();
  const nextEventSequence = metadata.nextEventSequence;

  await upsertOfflineRecord("syncMetadata", metadata.key, {
    ...metadata,
    nextEventSequence: nextEventSequence + 1,
  });

  return nextEventSequence;
}

export async function recordLastSyncedAt(lastSyncedAt: string): Promise<void> {
  const metadata = await getSyncMetadata();
  await upsertOfflineRecord("syncMetadata", metadata.key, {
    ...metadata,
    lastSyncedAt,
    lastError: null,
  });
}

export async function updateSyncMetadata(
  updates: Partial<Omit<OfflineSyncMetadataRecord, "key" | "nextEventSequence">>,
): Promise<void> {
  const metadata = await getSyncMetadata();
  await upsertOfflineRecord("syncMetadata", metadata.key, {
    ...metadata,
    ...updates,
  });
}
